(async () => {
  const root=document.querySelector('[data-ocm]'),source=window.OrliMultiCharmData;
  if(!root||!source)return;
  const data=await window.OrliPersonalisation.prepareData(source);
  const controls=data.controls,slots=controls.filter(c=>c.kind==='charm'),state={};
  const rows=root.querySelector('[data-ocm-rows]'),dialog=root.querySelector('[data-ocp-dialog]');
  const grid=root.querySelector('[data-ocp-grid]'),search=root.querySelector('[data-ocm-search]');
  const back=root.querySelector('[data-ocm-back]'),confirm=root.querySelector('[data-ocp-confirm]');
  const remove=root.querySelector('[data-ocm-remove]'),add=root.querySelector('[data-ocm-add]');
  const productRoot=root.closest('[id^="MainProduct--"]');
  const buy=productRoot?.querySelector('[id^="ProductSubmitButton"]');
  if(buy){buy.disabled=true;}
  const requiredSlots=slots.filter(slot=>slot.required);
  const visibleSlots=new Set((requiredSlots.length?requiredSlots:slots.slice(0,1)).map(slot=>slot.key));
  let current=null,draft=null,trigger=null,closing=false,closeTimer=null;
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const shared=window.OrliPersonalisation,pricing=shared.priceController(root);
  const money=shared.money,canShowTotal=pricing.enabled;
  const price=item=>item?(item.choice.price_pence||0)+(item.choice.child?(item.value.price_pence||0):0):0;
  const cost=value=>value.price_pence?` +${money.format(value.price_pence/100)}`:'';
  const make=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e;};
  const image=(value,size=160)=>{
    if(!value.image)return make('span','ocm-placeholder','◇');
    const img=make('img'),url=new URL(value.image,location.origin);
    if(url.hostname==='cdn.shopify.com')url.searchParams.set('width',String(size*2));
    img.src=url.href;img.alt=value.label.trim();img.width=size;img.height=size;img.loading='lazy';img.decoding='async';return img;
  };
  const text=item=>item?(item.choice.child?`${item.choice.label.trim()} · ${item.value.label.trim()}`:item.choice.label.trim()):'';
  // Keep source control identities for component lookup; only their public order changes.
  function activeSlots(){
    const optional=[...visibleSlots].map(key=>slots.find(slot=>slot.key===key)).filter(slot=>slot&&!slot.required);
    return [...requiredSlots,...optional.filter(slot=>state[slot.key]),...optional.filter(slot=>!state[slot.key])];
  }
  function orderedControls(){
    let inserted=false;
    return controls.flatMap(control=>{
      if(control.kind!=='charm')return [control];
      if(inserted)return [];inserted=true;return activeSlots();
    });
  }
  function publicLabel(control,label){
    if(control.kind!=='charm')return label;
    const number=activeSlots().findIndex(slot=>slot.key===control.key)+1;
    return label.replace(/\b(charm\s*)\d+\b/gi,(_,prefix)=>`${prefix}${number}`);
  }
  function sync(){
    rows.replaceChildren();
    for(const control of orderedControls()){
      const item=state[control.key],button=make('button','ocp-choice');button.type='button';
      button.dataset.ocmOpen=control.key;button.setAttribute('aria-haspopup','dialog');
      const thumb=make('span','ocp-choice-image');thumb.append(item?image(item.value,64):make('span','',control.kind==='clasp'?'○':'+'));
      const heading=make('strong','',publicLabel(control,control.label));
      if(control.required)heading.append(document.createTextNode(' '),make('span','ocm-required-badge',shared.settings.requiredLabel));
      const copy=make('span','ocp-choice-text');copy.append(heading,make('span','',item?text(item)+(price(item)?` · +${money.format(price(item)/100)}`:''):control.kind==='clasp'?'Choose your clasp':control.required?'Choose your charm':'Choose a charm (optional)'));
      button.append(thumb,copy,make('span','ocp-choice-action',item?'Edit':'Choose +'));
      button.addEventListener('click',()=>open(control,button));
      const row=make('div','ocm-row');row.append(button);
      if(control.kind==='charm'&&!control.required&&item){
        const removeRow=make('button','ocm-row-remove',shared.settings.removeLabel);removeRow.type='button';
        removeRow.dataset.ocmRemoveRow=control.key;removeRow.setAttribute('aria-label',`Remove ${publicLabel(control,control.label).toLowerCase()}`);
        removeRow.addEventListener('click',()=>{removeSlot(control);add.focus({preventScroll:true});});row.append(removeRow);
      }
      rows.append(row);
    }
    const count=slots.filter(s=>state[s.key]).length;
    root.querySelector('[data-ocp-progress]').textContent=`${count} of ${data.max_charms} charms`;
    add.hidden=visibleSlots.size>=slots.length;add.disabled=false;
    const properties={},paidSelections=[];
    for(const c of orderedControls()){
      const item=state[c.key];if(!item)continue;
      properties[publicLabel(c,c.property)]=item.choice.label;
      if(item.choice.child)properties[publicLabel(c,item.choice.child.property)]=item.value.label;
      if(price(item)>0){
        const selectedProperties={[publicLabel(c,c.property)]:item.choice.label};
        if(item.choice.child)selectedProperties[publicLabel(c,item.choice.child.property)]=item.value.label;
        paidSelections.push({key:window.OrliPersonalisationCommerce.key(data.set_id,c.property,item.choice.id,item.choice.child?item.value.id:''),price:price(item),units:1,properties:selectedProperties});
      }
    }
    if(data.more_charms_property&&count>3)properties[data.more_charms_property]=data.more_charms_value;
    root.dataset.orderProperties=JSON.stringify(properties);
    root.dataset.paidSelections=JSON.stringify(paidSelections);
    root.dataset.selectionComplete=String(controls.every(c=>!c.required||state[c.key]));
    const additional=Object.values(state).reduce((sum,item)=>sum+price(item),0);
    root.dataset.additionalPrice=String(additional);
    pricing.set(additional);
    shared.syncForm(root);
    root.querySelector('[data-ocm-price-summary]').textContent=canShowTotal
      ?`Your total: ${money.format(pricing.total()/100)}${additional?` · includes ${money.format(additional/100)} in selected extras`:''}`
      :`Selected extras: ${money.format(additional/100)} GBP`;
  }
  function removeSlot(control){
    if(control.required||control.kind!=='charm')return;
    delete state[control.key];visibleSlots.delete(control.key);sync();
  }
  function updateDraft(){
    confirm.disabled=!draft.value;
    root.querySelector('[data-ocp-draft-summary]').textContent=draft.value?text(draft):draft.choice?`Choose ${draft.choice.label.toLowerCase().includes('initial')?'your letter':draft.choice.label.toLowerCase().includes('birthstone')?'your month':'an option'} above`:current.kind==='clasp'?'Choose a clasp above':'Choose a charm above';
    remove.hidden=current.required||current.kind!=='charm'||!state[current.key];
  }
  function renderGrid(){
    const family=draft.choice?.child;
    search.hidden=current.kind==='clasp';
    root.querySelector('.ocm-search-label').hidden=search.hidden;
    back.hidden=!family;search.placeholder=shared.settings.searchPlaceholder;
    root.querySelector('.ocm-search-label').textContent=shared.settings.searchLabel;
    root.querySelector('[data-ocp-grid-label]').textContent=family?draft.choice.label.trim():current.kind==='clasp'?'Choose your clasp':'Explore the charms';
    grid.replaceChildren();grid.dataset.kind=family&&draft.choice.label.toLowerCase().includes('birthstone')?'birthstone':'charms';
    const query=search.value.trim().toLocaleLowerCase('en-GB');
    const values=(family?family.values:current.choices).filter(v=>!v.hidden&&v.label.toLocaleLowerCase('en-GB').includes(query));
    for(const value of values){
      const button=make('button','ocp-option');button.type='button';button.setAttribute('aria-label',value.label.trim());
      button.setAttribute('aria-pressed',String(!!draft.value&&draft.value.id===value.id));
      button.append(image(value),make('span','',value.label.trim()+cost(value)+(value.child?' ›':'')));
      button.addEventListener('click',()=>{
        if(!family&&value.child){draft={choice:value,value:null};search.value='';renderGrid();back.focus();}
        else{draft=family?{choice:draft.choice,value}:{choice:value,value};grid.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));updateDraft();}
      });grid.append(button);
    }
    if(!values.length)grid.append(make('p','ocm-empty','No matching charms. Try another search.'));
    updateDraft();
  }
  function open(control,button){
    if(closing)return;
    current=control;trigger=button;draft=state[control.key]?{...state[control.key]}:{choice:null,value:null};
    search.value='';root.querySelector('[data-ocp-dialog-title]').textContent=control.kind==='clasp'?'Choose your clasp':`Choose ${publicLabel(control,control.label).toLowerCase()}`;
    confirm.textContent=control.kind==='clasp'?'Use this clasp':'Use this charm';
    renderGrid();dialog.classList.remove('is-closing');dialog.showModal();
    root.querySelector('.ocp-drawer-body').scrollTop=0;document.documentElement.classList.add('ocp-dialog-open');
    root.querySelector('[data-ocp-close]').focus();
  }
  function finishClose(){
    clearTimeout(closeTimer);dialog.removeEventListener('animationend',exitEnded);dialog.close();dialog.classList.remove('is-closing');
    document.documentElement.classList.remove('ocp-dialog-open');closing=false;
    const target=root.querySelector(`[data-ocm-open="${current.key}"]`);(target||(trigger?.isConnected?trigger:add))?.focus({preventScroll:true});
  }
  function exitEnded(event){if(event.target===dialog&&event.animationName==='ocp-drawer-out')finishClose();}
  function close(){
    if(!dialog.open||closing)return;if(motion.matches){finishClose();return;}
    closing=true;dialog.style.setProperty('--ocp-close-from',getComputedStyle(dialog).transform);
    dialog.style.setProperty('--ocp-backdrop-from',getComputedStyle(dialog,'::backdrop').opacity);
    dialog.classList.add('is-closing');dialog.addEventListener('animationend',exitEnded);closeTimer=setTimeout(finishClose,420);
  }
  search.addEventListener('input',renderGrid);
  back.addEventListener('click',()=>{draft={choice:null,value:null};search.value='';renderGrid();search.focus();});
  confirm.addEventListener('click',()=>{
    if(!draft.value)return;
    if(current.kind==='charm'&&!current.required&&!state[current.key]){visibleSlots.delete(current.key);visibleSlots.add(current.key);}
    state[current.key]={...draft};sync();close();
  });
  remove.addEventListener('click',()=>{removeSlot(current);close();});
  add.addEventListener('click',()=>{const next=slots.find(slot=>!visibleSlots.has(slot.key));if(!next)return;visibleSlots.add(next.key);sync();const button=root.querySelector(`[data-ocm-open="${next.key}"]`);open(next,button);});
  root.querySelector('[data-ocp-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('click',event=>{if(event.target===dialog)close();});
  dialog.addEventListener('close',()=>{clearTimeout(closeTimer);closing=false;dialog.classList.remove('is-closing');document.documentElement.classList.remove('ocp-dialog-open');});
  productRoot?.addEventListener('change',()=>requestAnimationFrame(sync));
  sync();root.dataset.ocpReady='true';
})().catch(()=>window.OrliPersonalisation?.fail());
